module.exports = __webpack_public_path__ + "img/1723614530274-WhatsApp Image 2024-08-14 at 13.45.24.jpeg.c0dd9bb0.webp";